





















import {
  defineComponent,
  computed,
  ref,
  onMounted,
  PropType,
} from '@vue/composition-api';
import { v4 as uuid } from 'uuid';
import { FCImageProviderTypes } from '~/utils/helpers.types';
import { NuxtPictureProps } from './types/FCImage';

export type FCImageContainerType = 'block' | 'cover';

export const FCImageContainerTypeMap: Map<FCImageContainerType, string> = new Map([
  ['block', 'fc-image--block'],
  ['cover', 'fc-image--cover'],
]);

export default defineComponent({
  name: 'FCImage',
  inheritAttrs: false,
  props: {
    fcModifiers: {
      type: Object as PropType<Record<string, unknown>>,
      required: false,
      default: () => ({}),
    },
    fcProvider: {
      type: String as PropType<FCImageProviderTypes>,
      required: false,
      default: 'fcProvider',
    },
    mobilePositioning: {
      type: Boolean,
      default: false,
    },
    displayType: {
      type: String as PropType<FCImageContainerType>,
      required: false,
      default: '',
    },
    nuxtImageProps: {
      type: Object as PropType<Partial<NuxtPictureProps>>,
      required: true,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const key = ref(uuid());
    const initialWidth = ref(900);

    onMounted(() => {
      initialWidth.value = window.innerWidth;
    });

    const provideWebpFormat = computed((): 'webp' => 'webp');

    const imageContainerType = computed((): string | undefined => (
      FCImageContainerTypeMap.get(props.displayType as FCImageContainerType)
    ));

    const imageContainerClasses = computed((): string[] => [
      imageContainerType.value ?? '',
      props.mobilePositioning ? 'img-mobile-positioning' : '',
    ]);

    const imageProps = computed((): Partial<NuxtPictureProps> => {
      const { loading, ...rest } = props.nuxtImageProps ?? {};
      return { ...rest, loading: loading ?? 'lazy' };
    });

    return {
      key,
      initialWidth,
      provideWebpFormat,
      imageContainerClasses,
      imageContainerType,
      imageProps,
    };
  },
});
